import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Report = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9976 4.86991C22.9141 4.35391 23.9482 4.08282 25 4.08282C26.0518 4.08282 27.0858 4.35391 28.0023 4.86991C28.9189 5.38592 29.6869 6.12944 30.2324 7.02872L30.238 7.038L47.8838 36.4963L47.8997 36.5233C48.4341 37.4487 48.7168 38.4979 48.7198 39.5664C48.7228 40.635 48.4459 41.6858 47.9168 42.6141C47.3876 43.5425 46.6246 44.3161 45.7036 44.858C44.7826 45.3999 43.7358 45.6913 42.6673 45.703L42.6458 45.7032L7.33268 45.7031C6.26416 45.6914 5.21734 45.3999 4.29637 44.858C3.3754 44.3161 2.61237 43.5425 2.08321 42.6141C1.55404 41.6858 1.27718 40.635 1.28018 39.5664C1.28317 38.4979 1.56591 37.4487 2.10026 36.5233L2.11613 36.4963L19.7675 7.02871C20.313 6.12942 21.0811 5.38592 21.9976 4.86991ZM25 7.98907C24.6195 7.98907 24.2455 8.08713 23.914 8.27377C23.5838 8.45967 23.3069 8.72722 23.1097 9.05076L23.1074 9.05461L5.47647 38.4881C5.28744 38.82 5.18748 39.1953 5.18641 39.5774C5.18533 39.9639 5.28547 40.3439 5.47687 40.6797C5.66827 41.0155 5.94426 41.2953 6.27737 41.4914C6.60787 41.6858 6.98317 41.7911 7.36648 41.7969H42.6335C43.0168 41.7911 43.3921 41.6858 43.7226 41.4914C44.0557 41.2953 44.3317 41.0155 44.5231 40.6797C44.7145 40.3439 44.8146 39.9639 44.8136 39.5774C44.8125 39.1953 44.7125 38.82 44.5235 38.4881L26.8926 9.05461L26.8902 9.05076C26.6931 8.72722 26.4161 8.45967 26.0859 8.27377C25.7544 8.08713 25.3804 7.98907 25 7.98907ZM25 16.7969C26.0787 16.7969 26.9531 17.6713 26.9531 18.75V27.0833C26.9531 28.162 26.0787 29.0365 25 29.0365C23.9213 29.0365 23.0469 28.162 23.0469 27.0833V18.75C23.0469 17.6713 23.9213 16.7969 25 16.7969ZM25 33.4635C23.9213 33.4635 23.0469 34.338 23.0469 35.4167C23.0469 36.4953 23.9213 37.3698 25 37.3698H25.0208C26.0995 37.3698 26.974 36.4953 26.974 35.4167C26.974 34.338 26.0995 33.4635 25.0208 33.4635H25Z"
        fill={color}
      />
    </svg>
  )
}
